import { ChatDocument as ChatDocumentObject, chatState } from "@/app/chatState";
import { EntryItem, useRefState } from "@/components/UI/tools";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { appState } from "@/app/appState";

function withIntentLabel(base: string, intent?: string): string {
    const trimmed = intent?.trim();
    return trimmed ? `${base} - ${trimmed}` : base;
}

/**
 * The chat foldout for an uploaded document. Read-only by construction: there is
 * no content column and no revision navigation, because a document has neither.
 */
const ChatDocument = observer((params: { reload?: () => void, objKey: { type: "document", id: number }, tool_id?: string, intent?: string }) => {
    const [refresh, setRefresh] = useState(0);

    const [name, setName] = useRefState<string>("");
    const [ids, setIds] = useState<number[]>([]);
    const [id, setId] = useState<number>();

    const identity = (edit: boolean | number | undefined) => { };

    useEffect(() => {
        const obj = chatState.chatObjects.get(params.objKey) as ChatDocumentObject | undefined;

        if (!obj) {
            params.reload?.();
            return;
        }

        setName(obj.document?.variable_name ?? obj.label ?? "");
        setId(obj.document?.id);
        setRefresh(p => p + 1);
    }, [params.objKey, chatState.chatObjects.get(params.objKey)]);

    return (
        <div id={`document${params.objKey.id}`} title={`document${params.objKey.id}`} className="h-full w-full">
            <EntryItem
                lock={false}
                setEdit={() => { }}
                headerClickNavigateFunction={id ? () => chatState.openObject({ type: "document", id }) : undefined}
                readonly={true}
                name={withIntentLabel(appState.t("objects.list.document"), params.intent)}
                chatForm={true}
                loading={false}
                deleting={false}
                refreshCount={refresh}
                idParams={{
                    singular: { get: id, set: identity },
                    plural: { get: ids, set: setIds },
                }}
                nameColumn={{
                    type: "text",
                    value: name.current,
                    onChange: setName,
                    validator: () => true,
                    label: appState.t("objects.variableName"),
                }}
            />
        </div>
    );
});

export default ChatDocument;
